const GroupVisualizations = {
  STANDARD: "",
  SUBTOTAL_GROUP: "subtotalGroup"
} as const;

const ALL = Object.values(GroupVisualizations);

export default { ...GroupVisualizations, ALL };
